import { useQuery } from '@tanstack/react-query';
import { Navigate, Route, Routes } from 'react-router-dom';

import { AppShell } from '@/components/app-shell';
import { LoadingState } from '@/components/status-state';
import { getSession } from '@/lib/api';
import { plannedSections, sections } from '@/lib/sections';
import { DashboardPage } from '@/routes/dashboard-page';
import { PlannedPage } from '@/routes/planned-page';
import { SignInPage } from '@/routes/sign-in-page';
import type { AnalyticsSession } from '@sia/analytics-contracts';

function isAuthenticatedSession(
  value: AnalyticsSession | undefined,
): value is Extract<AnalyticsSession, { authenticated: true }> {
  return value?.authenticated === true;
}

export function App() {
  const session = useQuery({ queryKey: ['analytics-session'], queryFn: getSession, retry: false, staleTime: 60_000 });
  if (session.isLoading) return <div className="bootstrap-loading"><LoadingState /></div>;
  const authenticatedSession = isAuthenticatedSession(session.data) ? session.data : null;
  return <Routes>
    <Route path="/sign-in" element={authenticatedSession ? <Navigate to="/" replace /> : <SignInPage />} />
    <Route path="*" element={authenticatedSession ? <AppShell session={authenticatedSession}>
      <Routes>
        {sections.map((section) => <Route key={section.id} path={section.path} element={<DashboardPage section={section} />} />)}
        {plannedSections.map((section) => <Route key={section.path} path={section.path} element={<PlannedPage title={section.title} description={section.description} items={section.items} />} />)}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell> : <Navigate to="/sign-in" replace />} />
  </Routes>;
}
